import { Injectable } from '@angular/core';
import {ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class CallTraceService {

  constructor(private api: ApiService) { }

  traceCall(pkPortal: number, pkService: number, data: Object): Observable<any> {
      return this.api.get('vna/portal/' + pkPortal + '/service/' + pkService + '/call-trace', data);
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/trace/services/call-trace.service.ts